import { render, staticRenderFns } from "./ElListV2.vue?vue&type=template&id=fd9a8a7c"
import script from "./ElListV2.vue?vue&type=script&lang=js"
export * from "./ElListV2.vue?vue&type=script&lang=js"
import style0 from "./ElListV2.vue?vue&type=style&index=0&id=fd9a8a7c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports